import React, { ReactNode } from 'react';
import { mergeClasses } from '../utils/styles.util';

interface CardProps {
  onClick?: () => void;
  className?: string;
  children: ReactNode;
}

const Card: React.FC<CardProps> = ({ onClick, className, children }) => (
  <div className={mergeClasses("flex flex-col items-center border rounded-sm", onClick && "cursor-pointer", className)} onClick={onClick}>
    {children}
  </div>
);

export default Card;
